import React from "reactn";
import { BaseElement } from "js/elements/base/BaseElement";

export class WebView extends BaseElement {
    static get schema() {
        return {
            scale: 1,
            url: "https://www.beautiful.ai/?",
            fullBleed: false
        };
    }

    getCanvasMargins() {
        let fullBleed = this.model.fullBleed;
        if (fullBleed) {
            if (this.canvas.model.layout.showFooter) {
                return { left: 0, top: 0, bottom: 10, right: 0 };
            } else {
                return { left: 0, top: 0, bottom: 0, right: 0 };
            }
        } else {
            return { left: 50, top: 50, bottom: 50, right: 50 };
        }
    }

    _build() {
    }

    _calcProps(props, options) {
        let { size } = props;
        return { size };
    }

    get scale() {
        return this.model.scale || 1;
    }

    renderChildren(transition) {
        let styles = {
            pointerEvents: "auto",
            border: "solid 1px #aaa",
            transform: `scale(${this.scale})`,
            transformOrigin: "0 0",
            width: `${100 / this.scale}%`,
            height: `${100 / this.scale}%`,
        };

        return <iframe src={this.model.url} style={styles}/>;
    }
}

export const elements = {
    WebView
};

